<div class="asset-details-root">
    <div class="asset-details-header">
        <div class="row">
            <div class="asset-header-back-button col-auto" (click)="backClicked()">
                <button class="action-button"><svg width="15" height="12" viewBox="0 0 15 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344" stroke="#17171A"
                            stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div class="asset-header-info" [ngClass]="headerExpanded ? 'col-3' : 'col-4'">
                <div class="row">
                    <div class="col-12 header-title" *ngIf="!headerExpanded"><b>{{'MV_POLES.EDIT.MV_SLRN' |
                            translate}}</b></div>
                    <div class="col-10 header-title" *ngIf="headerExpanded"><b>MV Poles</b></div>
                    <!-- <div class="header-expand-button col-2" *ngIf="!headerExpanded">
                        <button class="header-button" (click)="headerExpanded = true">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14.1846 3.75V10.25M14.1846 10.25H20.6846M14.1846 10.25L20.6846 3.75M10.6846 20.25V13.75M10.6846 13.75H4.18457M10.6846 13.75L4.18457 20.25"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div> -->
                    <div *ngIf="!headerExpanded" class="light-gray-text col-auto">{{ selectedMvPole.slrn }}</div>
                    <div class="pill header-pill col-auto"
                        [ngClass]="{'light-gray-pill' : selectedMvPole.status == 'Pending',
                          'light-orange-pill' : selectedMvPole.status == 'Assigned' || selectedMvPole.status == 'Retagged', 
                          'green-success-pill': selectedMvPole.status == 'Complete', 'red-failure-pill': selectedMvPole.status == 'Rejected'}">
                        {{ selectedMvPole.status }} </div>
                    <div class="pill header-pill col-auto asset-type-pill">{{ mvPoleType | translate }} {{'COMMON.TYPE'
                        | translate | lowercase}}</div>
                </div>


                <div *ngIf="headerExpanded">MV Pole Details</div>
            </div>
            <div class="header-actions col">
                <button *ngIf="EMCConfiguration.includes(EntityModelConfiguration.Retag)" class="btn asset-header-action-button" data-bs-toggle="modal"
                    (click)="assetAssignType = AssetAssignType.Retagged;"
                    data-bs-target="#assignToFieldAgent">{{'COMMON.RETAG' | translate}}</button>
                <div *ngIf="EMCConfiguration.includes(EntityModelConfiguration.RecallValidatedTask) || EMCConfiguration.includes(EntityModelConfiguration.RecallAssignedTask)" class="recall-container position-relative d-inline-block">
                    <button class="btn asset-header-action-button"
                        (click)="showRecallMenu = !showRecallMenu">{{'COMMON.RECALL' | translate}}</button>
                    <div *ngIf="showRecallMenu" class="recall-options shadow-sm" @slideToggle>
                        <div class="recall-type"
                            *ngIf="EMCConfiguration.includes(EntityModelConfiguration.RecallAssignedTask)"
                            [ngClass]="!recallAssignedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
                            (click)="recallAssignedAllowed ? recall() : null">
                            <span>{{'COMMON.ASSIGNED_TASK' | translate}}</span>
                        </div>
                        <div class="recall-type"
                            *ngIf="EMCConfiguration.includes(EntityModelConfiguration.RecallValidatedTask)"
                            [ngClass]="!recallValidatedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
                            (click)="recallValidatedAllowed ? recall() : null">
                            <span>{{'COMMON.VALIDATED_TASK' | translate}}</span>
                        </div>
                    </div>
                </div>
                <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#updateStatus"
                    [disabled]="this.selectedMvPole.dataQualityId !== 0">{{'COMMON.UPDATE_STATUS' | translate}}</button>
                <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#auditReview"
                    [disabled]="selectedMvPole.auditedStatus === 'Audited'">{{'COMMON.FIELD_AUDIT' |
                    translate}}</button>
                <button class="btn asset-header-action-button" data-bs-toggle="modal"
                    (click)="assetAssignType = AssetAssignType.Assigned;"
                    data-bs-target="#assignToFieldAgent">{{'COMMON.ASSIGN_AGENT' | translate}}</button>
                <button *ngIf="!editEnabled" class="btn asset-header-action-button"
                    (click)="editEnabled = true">{{'COMMON.EDIT' |
                    translate}}</button>
                <button *ngIf="editEnabled" class="btn asset-header-action-button asset-header-save-button"
                    #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history">{{'COMMON.SAVE' |
                    translate}}</button>
            </div>
        </div>
    </div>
    <div class="asset-details-content">
        <div class="row">
            <div *ngIf="headerExpanded" class="col-3 expanded-header-info">
                <div class="collapse-header-button col">
                    <button class="action-button" (click)="headerExpanded = false">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.25 3.75H6.95C5.8299 3.75 5.26984 3.75 4.84202 3.96799C4.46569 4.15973 4.15973 4.46569 3.96799 4.84202C3.75 5.26984 3.75 5.8299 3.75 6.95V17.05C3.75 18.1701 3.75 18.7302 3.96799 19.158C4.15973 19.5343 4.46569 19.8403 4.84202 20.032C5.26984 20.25 5.8299 20.25 6.95 20.25H17.05C18.1701 20.25 18.7302 20.25 19.158 20.032C19.5343 19.8403 19.8403 19.5343 20.032 19.158C20.25 18.7302 20.25 18.1701 20.25 17.05V14.75M13.75 3.75H20.25M20.25 3.75V10.25M20.25 3.75L11 13"
                                stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </button>
                </div>
                <div class="expanded-header-info-title pt-4"><b>MV POLE</b></div>
                <div class="expanded-header-asset-states pt-3 row">
                    <div class="pill orange-pill">Residential</div>
                    <div class="pill light-gray-pill">Pending</div>
                    <div class="pill dark-gray-pill">Existing</div>
                </div>
                <div class="row pt-4">
                    <div class="col-4">Type</div>
                    <div class="col-8">Concrete</div>
                    <div class="col-4">Tag Status</div>
                    <div class="col-8">NA</div>
                    <div class="col-4">MV Pole SLRN</div>
                    <div class="col-8">ECG223123213221</div>
                    <div class="col-4">Remarks & Recommendations</div>
                    <div class="col-8">OK</div>
                </div>
            </div>
            <div class="col-xl-4 col-md-6">
                <div class="row">
                    <div class="asset-card col-11"
                        [ngClass]="informationCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                        <div class="asset-card-header row">
                            <h2 class="card-title asset-card-title col-10">{{'MV_POLES.ADD.POLE_INFO' | translate}}</h2>
                            <div class="collapse-arrow col-2">
                                <button class="action-button" (click)="informationCardExpanded = true"
                                    *ngIf="!informationCardExpanded">

                                    <svg *ngIf="!informationCardExpanded" width="10" height="6" viewBox="0 0 10 6"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="action-button" (click)="informationCardExpanded = false"
                                    *ngIf="informationCardExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>

                        </div>
                        <div *ngIf="informationCardExpanded" class="asset-card-content" @slideToggle>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.EDIT.MV_ID' | translate}}</div>
                                <div class="col-7 asset-card-content-value">{{ selectedMvPole.poleId | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.EDIT.MV_NUMBER' | translate}}
                                </div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    selectedMvPole.poleNumber | hasValue }}
                                </div>
                                <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.poleNumber" />
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.EDIT.MV_TYPE' | translate}}
                                </div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    mvPoleType | translate | hasValue }}
                                </div>
                                <div *ngIf="editEnabled" class="col-7">
                                    <select class="form-control" [(ngModel)]="selectedMvPole.poleType">
                                        <option *ngFor="let option of mvPoleTypeOptions" [value]="option.name">
                                            {{ option.translation | translate }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.EDIT.SHAPE' | translate}}</div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    mvPoleShape | translate | hasValue }}
                                </div>
                                <div *ngIf="editEnabled" class="col-7">
                                    <select class="form-control" [(ngModel)]="selectedMvPole.poleShape">
                                        <option *ngFor="let option of mvPoleShapeOptions" [value]="option.name">
                                            {{ option.translation | translate }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.CONDITION.TITLE' | translate}}
                                </div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    mvPoleCondition | translate | hasValue }}
                                </div>
                                <div *ngIf="editEnabled" class="col-7">
                                    <select class="form-control" [(ngModel)]="selectedMvPole.poleCondition">
                                        <option *ngFor="let option of mvPoleConditionOptions" [value]="option.name">
                                            {{ option.translation | translate }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.EDIT.STRUCTURE' | translate}}
                                </div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    mvPoleStructure | translate | hasValue }}
                                </div>
                                <div *ngIf="editEnabled" class="col-7">
                                    <select class="form-control" [(ngModel)]="selectedMvPole.poleStructure">
                                        <option *ngFor="let option of mvPoleStructureOptions" [value]="option.name">
                                            {{ option.translation | translate }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.EDIT.CROSS_ARM_COND' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.crossArmCondition |
                                    hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.EDIT.LV_RETICULATION' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.lvReticulation | hasValue
                                    }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.ADDRESS' | translate}}</div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    selectedMvPole.address | hasValue }}
                                </div>
                                <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.address" />

                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.LANDMARK' | translate}}</div>
                                <div *ngIf="!editEnabled" class="col-7 asset-card-content-value">{{
                                    selectedMvPole.landmark | hasValue }}
                                </div>
                                <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.landmark" />

                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'COMMON.COMMENT' | translate}}</div>
                                <div class="col-7 asset-card-content-value">{{ selectedMvPole.comment | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-5 asset-card-content-title">{{'MV_POLES.GEOLOCATION' | translate}}</div>
                                <div class="col-6 asset-card-content-value">{{ selectedMvPole.latitude }}, {{
                                    selectedMvPole.longitude }}</div>
                                <div class="geo-icon col-auto" (click)="isMapVisible = !isMapVisible">
                                    <svg width="16" height="16" viewBox="0 0 16 16" data-bs-toggle="modal"
                                        data-bs-target="#showMap" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                                            fill="var(--primary-color)" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="asset-card col-11"
                        [ngClass]="networkInfoExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                        <div class="asset-card-header row">
                            <h2 class="card-title asset-card-title col-10">{{'MV_POLES.NETWORK_INFO.MV_NETWORK_INFO' |
                                translate}}</h2>
                            <div class="collapse-arrow col-2">
                                <button class="action-button" (click)="networkInfoExpanded = true"
                                    *ngIf="!networkInfoExpanded">

                                    <svg *ngIf="!networkInfoExpanded" width="10" height="6" viewBox="0 0 10 6"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="action-button" (click)="networkInfoExpanded = false"
                                    *ngIf="networkInfoExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>

                        </div>
                        <div *ngIf="networkInfoExpanded" class="asset-card-content" @slideToggle>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.NETWORK_INFO.TS' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.transmissionSubstationName : selectedMvPole.transmissionStation) |
                                    hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.NETWORK_INFO.33KV_FEEDER_NAME' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.incomingAcLineName : selectedMvPole.feeder33Name) | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.NETWORK_INFO.INJ_SS_NAME' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.substationName : selectedMvPole.injectionSubstation) |
                                    hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.NETWORK_INFO.11KV_FEEDER_NAME' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.acLineName : selectedMvPole.feeder11Name) | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.BU.SINGLE' | translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.geographicalRegionName : selectedMvPole.region) | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.UT.SINGLE' | translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ (hasCimDataIntegration ? selectedMvPole.subGeographicalRegionName : selectedMvPole.district) | hasValue }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-md-6">
                <div class="row">
                    <div class="asset-card col-11"
                        [ngClass]="devicesCardExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                        <div class="asset-card-header row">
                            <h2 class="card-title asset-card-title col-10">{{'MV_POLES.DEVICES.MV_DEVICES' | translate}}
                            </h2>
                            <div class="collapse-arrow col-2">
                                <button class="action-button" (click)="devicesCardExpanded = true"
                                    *ngIf="!devicesCardExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="action-button" (click)="devicesCardExpanded = false"
                                    *ngIf="devicesCardExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>

                        </div>
                        <div *ngIf="devicesCardExpanded" class="asset-card-content" @slideToggle>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.DEVICES.INSULATORS' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.insulators | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.DEVICES.GROUNDING_SYSTEM' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.groundingSystem | hasValue
                                    }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.EDIT.CROSS_ARM' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.crossArm | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.DEVICES.STAY_WIRE' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.stayWire | hasValue }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="asset-card col-11"
                        [ngClass]="userActivityExpanded ? 'asset-card-expanded' : 'asset-card-collapsed'">
                        <div class="asset-card-header row">
                            <h2 class="card-title asset-card-title col-10">{{'MV_POLES.USER_ACTIVITY' | translate}}</h2>
                            <div class="collapse-arrow col-2">
                                <button class="action-button" (click)="userActivityExpanded = true"
                                    *ngIf="!userActivityExpanded">

                                    <svg *ngIf="!userActivityExpanded" width="10" height="6" viewBox="0 0 10 6"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="action-button" (click)="userActivityExpanded = false"
                                    *ngIf="userActivityExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>

                        </div>
                        <div *ngIf="userActivityExpanded" class="asset-card-content" @slideToggle>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.USER.TYPE.FIRST_CAPTURED' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.firstCapturedUser |
                                    hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.USER.TYPE.LAST_UPDATED' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.lastUpdateUser | hasValue
                                    }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'MV_POLES.CREATION_DATE' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.creationDate |
                                    date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.MBC_DETAILS.UPDATED_DATE' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.lastUpdate |
                                    date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.USER.TYPE.REASSIGNED' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.reassignedBy | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.MBC_DETAILS.ASSIGNED' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.assignedUser | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.VALIDATION_STATUS' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.dataQualityStatus | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.USER.TYPE.VALIDATED' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.validatedBy | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.DATE_TYPE.VALIDATED' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.validationDate |
                                    date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.MBC_DETAILS.AUDITED_STATUS' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.auditedStatus | hasValue
                                    }}</div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.USER.TYPE.AUDITED' | translate}}
                                </div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.auditedBy | hasValue }}
                                </div>
                            </div>
                            <div class="asset-card-info row">
                                <div class="col-7 asset-card-content-title">{{'COMMON.MBC_DETAILS.AUDITED_DATE' |
                                    translate}}</div>
                                <div class="col-5 asset-card-content-value">{{ selectedMvPole.auditedDate |
                                    date:'dd/MM/yyyy':'{{ timeZone }}' | hasValue }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="row">
                    <div class="asset-images-section col">
                        <div class="asset-card-header asset-images-header mb-5 row">
                            <h2 class="card-title asset-card-title col-10">{{'COMMON.PICTURES.UPLOADED_IMAGES' |
                                translate}}</h2>
                            <div class="collapse-arrow col-2">
                                <button class="action-button" (click)="imagesExpanded = true" *ngIf="!imagesExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="action-button" (click)="imagesExpanded = false" *ngIf="imagesExpanded">

                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5L5 1L1 5" stroke="#17171A" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>
                        </div>
                        <div *ngIf="imagesExpanded" class="asset-images-content" @slideToggle>
                            <app-image-section [image]="getBuildingMountedImage()"
                                [title]="'COMMON.PICTURES.TAG_MOUNTED'" [index]="0" [imageType]="ImageType.MountedTag"
                                [editEnabled]="editEnabled" [inputId]="'fileMountedTag' + 0"
                                [imageSectionExpanded]="tagImageExpanded" (imageClick)="showImage(ImageType.MountedTag)"
                                (fileChange)="fileBrowserHandler($event)">
                            </app-image-section>
                            <app-image-section [image]="getMvPoleCrossArmImage()" [title]="'COMMON.PICTURES.MV_CROSS_ARM'"
                                [index]="0" [imageType]="ImageType.MvPoleCrossArm" [editEnabled]="editEnabled"
                                [inputId]="'fileMvPoleCrossArm' + 0" [imageSectionExpanded]="MvPoleCrossArmImageExpanded"
                                (imageClick)="showImage(ImageType.MvPoleCrossArm)"
                                (fileChange)="fileBrowserHandler($event)">
                            </app-image-section>
                            <app-image-section [image]="getMvPoleLeftImage()" [title]="'COMMON.PICTURES.MV_POLE_LEFT'"
                                [index]="0" [imageType]="ImageType.MVPoleLeft" [editEnabled]="editEnabled"
                                [inputId]="'fileLeftMvPole' + 0" [imageSectionExpanded]="MvPoleLeftImageExpanded"
                                (imageClick)="showImage(ImageType.MVPoleLeft)"
                                (fileChange)="fileBrowserHandler($event)">
                            </app-image-section>
                            <app-image-section [image]="getMvPoleRightImage()" [title]="'COMMON.PICTURES.MV_POLE_RIGHT'"
                                [index]="0" [imageType]="ImageType.MVPoleRight" [editEnabled]="editEnabled"
                                [inputId]="'fileMvPoleRight' + 0" [imageSectionExpanded]="MvPoleRightImageExpanded"
                                (imageClick)="showImage(ImageType.MVPoleRight)"
                                (fileChange)="fileBrowserHandler($event)">
                            </app-image-section>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
    (shown.bs.modal)="onModalOpen()">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-image">
            <div class="modal-body modal-body-image">
                <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
                    <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage"
                        [thumbImage]="selectedImage" [magnification]="3">
                    </lib-ngx-image-zoom>
                </div>
                <div class="rotate-div">
                    <button class="btn btn-primary left-button" (click)="rotateLeft()">
                        &lt;
                    </button>
                    <button class="btn btn-primary right-button" (click)="rotateRight()">
                        &gt;
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-asset-map [setMapVisibility]="isMapVisible" [longitude]="longitude" [latitude]="latitude">
                </app-asset-map>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalAssignFade()"
    (shown.bs.modal)="onAssignModalShown()">
    <app-assign-task-modal [areaId]="selectedMvPole.districtId" [assignTask]="assignTask"
        (idSelected)="selectFieldAgent($event)">

    </app-assign-task-modal>
</div>

<div class="modal fade" id="auditReview" tabindex="-1" aria-hidden="true">
    <app-audit-review assetType="MvPole" [assetId]="selectedMvPole.id"
        [areaId]="selectedMvPole.districtId"></app-audit-review>
</div>
<app-history (update)="updateHistory($event)"></app-history>

<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
    <app-data-quality assetType="MvPole" [assetId]="selectedMvPole.id"
        [areaId]="selectedMvPole.districtId"></app-data-quality>
</div>